import PropTypes from 'prop-types'
import classnames from 'classnames'

const TextInputGroup = ({
  label,
  name,
  value,
  placeholder,
  type,
  onChange,
  error
}) => (
  <div className="form-group">
    {label && <label htmlFor={name}>{label}</label>}
    <input
      type={type}
      name={name}
      className={classnames('form-control form-control-lg', {
        'is-invalid': error
      })}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
    {error && (
      <div style={{ color: 'red' }} className="invalid-feedback">
        {error}
      </div>
    )}
  </div>
)

TextInputGroup.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  error: PropTypes.string
}

TextInputGroup.defaultProps = { type: 'text' }

export default TextInputGroup
